import React, { useMemo } from 'react';
import numeral from 'numeral';
import InvestmentItemSC from './investment-item.styled';
import { SmallText, BodyText } from '../../typography';
import Mark from '../../ui/mark';
import dlt from '../../../utils/default-lang';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as RightArrowIcon } from '../../../assets/img/svg/right-arrow-b.svg';
import Moment from 'react-moment';
import { Link, withRouter } from 'react-router-dom';

const InvestmentItem = ({
  id,
  date,
  amount,
  status,
  name,
  payments,
  paymentsTotal,
  isTablet,
  hasPagination,
  inArrear,
  lastPaymentDate,
  history,
}) => {
  const statusMark = useMemo(() => {
    switch (status) {
      case 'sold':
        return (
          <Mark colorStyle="OUTLINE_GRAY">
            <FormattedMessage id="global_sold" defaultMessage={dlt['global_sold']} />
          </Mark>
        );
      case 'paying':
        return (
          <Mark colorStyle="GREEN">
            <FormattedMessage id="global_paying" defaultMessage={dlt['global_paying']} />
          </Mark>
        );
      case 'high-delay':
      case 'medium-delay':
        return (
          <Mark colorStyle={status === 'medium-delay' ? 'GRAY' : 'RED'}>
            <FormattedMessage id="global_late" defaultMessage={dlt['global_late']} /> {inArrear}{' '}
            {inArrear === 1 ? (
              <FormattedMessage id="global_day" defaultMessage={dlt['global_day']} />
            ) : inArrear > 1 && inArrear <= 4 ? (
              <FormattedMessage id="global_more_days" defaultMessage={dlt['global_more_days']} />
            ) : (
              <FormattedMessage id="global_days" defaultMessage={dlt['global_days']} />
            )}
          </Mark>
        );
      case 'paid':
        return (
          <Mark colorStyle="DARK_GREEN">
            <FormattedMessage id="global_paid_all" defaultMessage={dlt['global_paid']} />
          </Mark>
        );
      default:
        return (
          <Mark colorStyle="GREEN">
            <FormattedMessage id="global_paying" defaultMessage={dlt['global_paying']} />
          </Mark>
        );
    }
  }, [inArrear, status]);

  return (
    <InvestmentItemSC hasPagination={hasPagination}>
      {isTablet ? (
        <td>
          <Link to={{ pathname: `/investments/${id}`, state: history.location.state }}>
            <BodyText className="bolder">{name}</BodyText>
            <BodyText className="bolder">{numeral(amount).format('0,00.00')} €</BodyText>
          </Link>
        </td>
      ) : (
        <>
          <td>
            <Link to={{ pathname: `/investments/${id}`, state: history.location.state }}>
              <BodyText className="bolder">{name}</BodyText>
            </Link>
          </td>
          <td>
            <Link to={{ pathname: `/investments/${id}`, state: history.location.state }}>
              <BodyText>{numeral(amount).format('0,00.00')} €</BodyText>
            </Link>
          </td>
        </>
      )}

      {isTablet ? null : (
        <td>
          <Link to={{ pathname: `/investments/${id}`, state: history.location.state }}>
            <BodyText>
              {payments} / {paymentsTotal}
            </BodyText>
          </Link>
        </td>
      )}

      {isTablet ? (
        <td>
          <Link to={{ pathname: `/investments/${id}`, state: history.location.state }}>
            <SmallText className="black-transparent">
              <Moment parse="DD.MM.YYYY" format="DD. MMMM YYYY">
                {date}
              </Moment>
            </SmallText>
            <SmallText className="bolder">{statusMark}</SmallText>
          </Link>
        </td>
      ) : (
        <>
          <td>
            <Link to={{ pathname: `/investments/${id}`, state: history.location.state }}>
              <BodyText>
                <Moment parse="DD.MM.YYYY" format="DD. MMMM YYYY">
                  {date}
                </Moment>
              </BodyText>
            </Link>
          </td>
          <td>
            <Link to={{ pathname: `/investments/${id}`, state: history.location.state }}>
              <BodyText>
                {lastPaymentDate ? (
                  <Moment parse="DD.MM.YYYY" format="DD. MMMM YYYY">
                    {lastPaymentDate}
                  </Moment>
                ) : (
                  '-'
                )}
              </BodyText>
            </Link>
          </td>

          <td>
            <Link to={{ pathname: `/investments/${id}`, state: history.location.state }}>
              <SmallText className="bolder">{statusMark}</SmallText>
            </Link>
          </td>
          <td>
            <Link to={{ pathname: `/investments/${id}`, state: history.location.state }}>
              <RightArrowIcon />
              {/*  <Button type="OUTLINED" className="detailpdetail-button" onClick={() => onDetailClick()}>
              <FormattedMessage id="global_detail" defaultMessage={dlt['global_detail']} />
              </Button> */}
            </Link>
          </td>
        </>
      )}
    </InvestmentItemSC>
  );
};

export default withRouter(InvestmentItem);
